module.exports = __webpack_public_path__ + "static/BIMViewer@2x-min-b0149e9ce93c702b84e7ca83c7484412.png";